import React from 'react';
import styled from 'styled-components';
import axios from 'axios';
import {
  IconButton, Typography, Snackbar, SnackbarContent,
} from '@material-ui/core';
import {
  MdDelete, MdGroupAdd, MdClose, MdEdit,
} from 'react-icons/lib/md';

import { getUsersList } from '../../services/manageUserServices';
import blockProps from '../../utils/blockProps';
import AppShell from '../../components/AppShell';
import Loader from '../../components/Loader';
import DataTable from '../../components/DataTable';
import ModalForm from '../../components/ModalForm';
import ModalConfirmation from '../../components/ModalConfirmation';

class ManageUser extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dataLoaded: false,
      usersList: [],
      headers: [],
      error: null,
      loading: false,
      snackbarOpened: false,
      snackbarMessage: '',
      serverError: false,
    };

    this.dataTableRef = null;
  }

  componentDidMount() {
    this.unsubscribe = getUsersList((usersList) => {
      const modifiedData = usersList.map(userData => ({
        ...userData,
        type:
          userData.type === 'CITY_IMPACT_MANAGER'
            ? 'Programme Associate'
            : userData.type.split('_').join(' '),
      }));
      this.setState({ usersList: modifiedData });
    });

    this.fetchDatatableHeaders();
  }

  componentWillUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }

  fetchDatatableHeaders = async () => {
    try {
      const { data } = await axios.options(
        ' https://us-central1-jyp-admin-saas.cloudfunctions.net/datatable/user/',
      );
      const response = data.data || [];

      this.setState({ dataLoaded: true, headers: response });
    } catch (error) {
      this.setState({ dataLoaded: true, error: error.message });
    }
  };

  handleSnackbarClose = () => {
    this.setState({
      snackbarOpened: false,
      snackbarMessage: '',
      serverError: false,
    });
  };

  deleteUser = async (userId, closeModal) => {
    this.setState({ loading: true });
    try {
      const { data } = await axios.delete(
        `https://us-central1-jyp-admin-saas.cloudfunctions.net/user/${userId}`,
      );
      const response = data.data || {};

      this.setState(
        {
          loading: false,
          snackbarOpened: true,
          snackbarMessage: response.message,
        },
        () => {
          if (this.dataTableRef) {
            this.dataTableRef.resetSelectedRows();
          }
          closeModal();
        },
      );
    } catch (error) {
      const errorMessages = error.response && error.response.data && error.response.data.error;
      this.setState({
        loading: false,
        serverError: true,
        snackbarOpened: true,
        snackbarMessage: errorMessages || 'something went wrong',
      });
    }
  };

  renderToolbars = selectedRows => (
    <div>
      {selectedRows.length === 1 && (
        <ContentContainer>
          <ModalForm
            tooltipTitle="Edit User"
            trigger={(
              <IconButton aria-label="Edit User">
                <MdEdit size={24} />
              </IconButton>
)}
            apiEndpoint={`https://us-central1-jyp-admin-saas.cloudfunctions.net/user/${
              selectedRows[0]
            }`}
            method="put"
            onClose={() => {
              if (this.dataTableRef) {
                this.dataTableRef.resetSelectedRows();
              }
            }}
          />
          <ModalConfirmation
            trigger={(
              <IconButton aria-label="Delete">
                <MdDelete />
              </IconButton>
)}
            onConfirm={({ closeModal }) => {
              this.deleteUser(selectedRows[0], closeModal);
            }}
          />
        </ContentContainer>
      )}
      {selectedRows.length === 0 && (
        <ContentContainer>
          <ModalForm
            tooltipTitle="Add User"
            trigger={(
              <IconButton aria-label="Add User">
                <MdGroupAdd size={24} />
              </IconButton>
)}
            apiEndpoint="https://us-central1-jyp-admin-saas.cloudfunctions.net/user/"
          />
        </ContentContainer>
      )}
    </div>
  );

  render() {
    return (
      <div>
        <AppShell>
          {this.state.error ? (
            <Typography variant="subheading" color="error">
              {this.state.error}
            </Typography>
          ) : (
            <div>
              {!this.state.dataLoaded ? (
                <Loader />
              ) : (
                <DataTable
                  ref={(comp) => {
                    this.dataTableRef = comp;
                  }}
                  title="Users"
                  tableHeaders={this.state.headers}
                  tableData={this.state.usersList}
                  renderToolbars={selectedRows => this.renderToolbars(selectedRows)}
                />
              )}
            </div>
          )}
        </AppShell>

        <Snackbar
          open={this.state.snackbarOpened}
          autoHideDuration={3000}
          onClose={this.handleSnackbarClose}
        >
          <StyledSnackbarContent
            serverError={this.state.serverError}
            message={this.state.snackbarMessage}
            action={[
              <IconButton
                key="close"
                aria-label="Close"
                color="inherit"
                onClick={this.handleSnackbarClose}
              >
                <MdClose size={20} />
              </IconButton>,
            ]}
          />
        </Snackbar>

        {this.state.loading && <Loader />}
      </div>
    );
  }
}

export default ManageUser;

const ContentContainer = styled.div`
  display: flex;
  align-items: center;

  & > * + * {
    margin-left: 10px !important;
  }
`;

const StyledSnackbarContent = styled(blockProps(SnackbarContent, ['serverError']))`
  background-color: ${props => (props.serverError ? 'red' : 'green')} !important;
`;



// WEBPACK FOOTER //
// ./src/pages/ManageUser/ManageUser.js